import { useProduct } from '@/api/inventory-management/products/useProduct';
import useProductVariant from '@/api/inventory-management/products/useProductVariant';
import { productVariantLabel } from './productVariantLabel';

/**
 * Label for a variant id. The variant's own invoice name (Famous NAMEINVC)
 * when it has one, else the product name with the SKU, else the SKU, else
 * the id. Variants in produce catalogs often carry no SKU and a generic
 * product name, so the invoice name is the one a reviewer recognizes.
 */
export function useProductVariantDisplayLabel(
  id: string | null,
): string | null {
  const stored = useProductVariant(id ?? '', { enabled: Boolean(id) });
  const variant = stored.data?.productVariant;
  const product = useProduct(variant?.productId, undefined, Boolean(variant));
  if (!id) return null;
  const invoiceName = variantInvoiceName(variant?.originMetadata);
  if (invoiceName) return invoiceName;
  const sku = variant?.sku?.trim() || null;
  const productName = product.data?.product.name?.trim() || null;
  if (productName) return productVariantLabel(productName, sku);
  return sku ?? id;
}

/** Famous stores the customer-facing variant name on `originMetadata.NAMEINVC`. */
function variantInvoiceName(
  originMetadata: Record<string, unknown> | null | undefined,
): string | null {
  const name = originMetadata?.NAMEINVC;
  return typeof name === 'string' && name.trim() ? name.trim() : null;
}
